var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var stringWidth = require('string-width');

var SPEECH_DELIMITERS = {
  first: ['/', '\\'],
  middle: ['|', '|'],
  last: ['\\', '/'],
  only: ['<', '>']
};
var THOUGHT_DELIMITERS = {
  first: ['(', ')'],
  middle: ['(', ')'],
  last: ['(', ')'],
  only: ['(', ')']
};

exports.say = function (text, wrap) {
  return format(text, wrap, SPEECH_DELIMITERS);
};

exports.think = function (text, wrap) {
  return format(text, wrap, THOUGHT_DELIMITERS);
};

function format(text, wrap, delimiters) {
  var lines = split(text, wrap);

  if (lines.length === 0) {
    lines = [''];
  }

  var maxLength = Math.max.apply(Math, _toConsumableArray(lines.map(function (line) {
    return stringWidth(line);
  })));
  var balloon = [top(maxLength)].concat(_toConsumableArray(lines.map(function (line, i) {
    var only = lines.length === 1;
    var first = i === 0;
    var last = i === lines.length - 1;
    var type = only ? 'only' : first ? 'first' : last ? 'last' : 'middle';

    var _delimiters$type = _slicedToArray(delimiters[type], 2),
        start = _delimiters$type[0],
        end = _delimiters$type[1];

    return "".concat(start, " ").concat(pad(line, maxLength), " ").concat(end);
  })), [bottom(maxLength)]);
  return balloon.join('\n');
}

function split(text, wrap) {
  text = text.replace(/\r\n?|[\n\u2028\u2029]/g, '\n').replace(/^\uFEFF/, '').replace(/\t/g, '        ');
  var lines = [];

  if (wrap) {
    text = text.split(/\s+/).join(' ');
    var start = 0;

    while (start < text.length) {
      var end = Math.min(start + wrap, text.length);
      var space = text.lastIndexOf(' ', end);

      if (end < text.length && space > start) {
        end = space;
      }

      lines.push(text.substring(start, end));

      if (space > start) {
        start = end + 1;
      } else {
        start = end;
      }
    }
  } else {
    lines = text.split('\n');
  }

  return lines;
}

function pad(text, length) {
  var trailingSpaces = new Array(length - stringWidth(text) + 1).join(' ');
  return text + trailingSpaces;
}

function top(length) {
  return ' ' + new Array(length + 3).join('_');
}

function bottom(length) {
  return ' ' + new Array(length + 3).join('-');
}